import apiUrl from "../../../utils/settings";

export const getAllCompanyProprietorsUrl = () => {
  return apiUrl + '/company/proprietors';
};

export const createPersonalProfilerUrl = () => {
  return apiUrl + '/v3/user/personal-profiler/';
};

export const getAllGendersUrl = () => {
  return apiUrl + '/v3/user/personal-profiler/genders/all';
};

export const getAllQualificationUrl = () => {
  return apiUrl + '/v3/user/personal-profiler/qualification/all';
};

export const getAllRealtionUrl = () => {
  return apiUrl + '/v3/user/personal-profiler/relationships/all';
};

export const getAllLanguageUrl = () => {
  return apiUrl + '/v3/user/personal-profiler/language/all';
};
export const getAllHealthConcernsUrl = () => {
  return apiUrl + '/v2/user/personal-profiler/health_concerns/all';
};

export const getAllMealUrl = () => {
  return apiUrl + '/v2/user/personal-profiler/conference_meal/all';
};

export const getAllBloodGroupsUrl = () => {
  return apiUrl + '/v2/user/personal-profiler/blood_groups/all';
};

export const getAllBusinessRoleUrl = () => {
  return apiUrl + '/v3/user/business-profiler/rolestype/all';
};


export const getAllBusinessIndustriesUrl = () => {
  return apiUrl + '/v3/user/business-profiler/industries/all';
};

export const getAllBusinessUomUrl = () => {
  return apiUrl + '/v3/user/business-profiler/uom/all';
};

export const getAllBusinessStoreTypesUrl = () => {
  return apiUrl + '/v3/user/business-profiler/storetypes/all';
};

export const getAllBusinessTypesOfProductsUrl = () => {
  return apiUrl + '/v3/user/business-profiler/typesofproducts/all';
};

export const getAllBusinessBrandsRangeUrl = () => {
  return apiUrl + '/v3/user/business-profiler/brandsrange/all';
};

export const getAllBusinessMonthlyTurnOverUrl = () => {
  return apiUrl + '/v3/user/business-profiler/monthlyturnoverlacs/all';
};

export const businessProfilerUrl = () => {
  return apiUrl + '/v3/user/business-profiler/';
};

export const getAllBrandMonthlyVolumeUrl = () => {
  return apiUrl + '/v3/user/business-profiler/brand_monthly_volume/all';
};